<!-- VALIDATOR GENERICOS -->
<small *ngIf="validatorMessage && controls?.errors?.required && (controls?.dirty || controls?.touched) && submitted"
	class="text-danger">
	El campo {{label}} es requerido<br>
</small>
<small *ngIf="validatorMessage && controls?.errors?.minlength && (controls?.dirty || controls?.touched) && submitted"
	class="text-danger">
	El campo {{label}} requiere {{controls.errors.minlength.requiredLength}} caracteres minimo.<br>
</small>
<small *ngIf="validatorMessage && controls?.errors?.maxlength && (controls?.dirty || controls?.touched) && submitted"
	class="text-danger">
	El campo {{label}} requiere {{controls.errors.maxlength.requiredLength}} caracteres maximo.<br>
</small>
<small *ngIf="validatorMessage && controls?.errors?.pattern && (controls?.dirty || controls?.touched) && submitted"
	class="text-danger">
	El campo {{label}} tiene formato incorrecto.<br>
</small>
<small *ngIf="validatorMessage && controls?.errors?.min && (controls?.dirty || controls?.touched) && submitted "
	class="text-danger">
	El valor minimo del campo {{label}} es: {{controls?.errors?.min.min}}
</small>
<small *ngIf="validatorMessage && controls?.errors?.max && (controls?.dirty || controls?.touched) && submitted "
	class="text-danger">
	El valor máximo del campo {{label}} es: {{controls?.errors?.max.max}}
</small>
<!-- CUSTOM VALIDATOR  -->
<small *ngIf="validatorMessage && controls?.errors?.customValidator && (controls?.dirty || controls?.touched) && submitted"
	class="text-danger">
	{{ controls.errors?.customValidator.message}}<br>
</small>